import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const UserGroupService = {
  getUserGroups(obj) {
    return httpClient.post(endPoints.getUserGroups, obj);
  },
  deleteUserGroup(obj) {
    return httpClient.post(endPoints.deleteUserGroup, obj);
  },
  updateUserGroup(obj) {
    return httpClient.post(endPoints.updateUserGroup, obj);
  },
  addUserGroup(obj) {
    return httpClient.post(endPoints.addUserGroup, obj);
  }
};

export default UserGroupService;



// WEBPACK FOOTER //
// ./src/service/UserGroupService.js